import { Component, OnInit, Input, AfterViewChecked } from '@angular/core';
import { UsersService } from 'src/app/shared/services/common/users.service';
import { DocumentService } from 'src/app/shared/services/documents/document.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';

@Component({
  selector: 'app-adjustment-summary',
  templateUrl: './adjustment-summary.component.html',
  styleUrls: ['./adjustment-summary.component.css']
})

export class AdjustmentSummaryComponent implements OnInit, AfterViewChecked {

  constructor(
    private usersService: UsersService,
    private documentService: DocumentService,
    private notificationService: DisplayNotificationService) { }
  summaryRecord: any;

  @Input()
  set adjustmentSummaryRecord(selectedAdjRecord: any) {
    if (selectedAdjRecord) {
      this.summaryRecord = selectedAdjRecord;
    }
  }

  ngOnInit() {
  }

  ngAfterViewChecked() {
    if (this.summaryRecord) {
      const element = document.getElementById('main-header');
      const positionInfoHeader = element.getBoundingClientRect();
      const elementFooter = document.getElementById('main-footer');
      const positionInfoFooter = elementFooter.getBoundingClientRect();
      const elementhstry = document.getElementById('history-container');
      const positionInfohstry = elementhstry.getBoundingClientRect();
      const elementStrock = document.getElementById('stroke-separator');
      const positionInfoStrock = elementStrock.getBoundingClientRect();
      const elementSumHeader = document.getElementById('summary-header');
      const positionInfoSumHeader = elementSumHeader.getBoundingClientRect();
      const headAndFootHeight = positionInfoHeader.height + positionInfoFooter.height;
      const historyContainerHeight = positionInfohstry.height + positionInfoStrock.height + positionInfoSumHeader.height;
      const elementsHeight = ((headAndFootHeight + historyContainerHeight) + 22);
      const overAllHeight = document.documentElement.clientHeight;
      const remaningHeight = overAllHeight - elementsHeight;
      const screenWidth = screen.width;
      if (screenWidth > 992.98) {
        document.getElementById('summary-data').style.maxHeight = remaningHeight + 'px';
      } else {
        document.getElementById('summary-data').style.maxHeight = 'inherit';
      }
    }
  }

  downloadAdjFile(summaryRecord: any) {
    const inputData = {
      userInfo: this.usersService.UserInfo(),
      adjustmentId: this.summaryRecord.id
    };
    const fileName = this.summaryRecord.fileName;
    this.documentService.viewAdjFile(inputData, fileName).subscribe(() => {
      summaryRecord.isClicked = !summaryRecord.isClicked;
    }, (err: HttpErrorResponse) => {
      console.log(err);
      summaryRecord.isClicked = !summaryRecord.isClicked;
      this.notificationService.setErrorNotification();
    });
  }

}
